import { render, staticRenderFns } from "./CatalogueList.vue?vue&type=template&id=0daa0fd4&scoped=true&lang=pug&"
import script from "./CatalogueList.vue?vue&type=script&lang=js&"
export * from "./CatalogueList.vue?vue&type=script&lang=js&"
import style0 from "./CatalogueList.vue?vue&type=style&index=0&id=0daa0fd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daa0fd4",
  null
  
)

export default component.exports